const $window = $(window),
        $body = $('body');

